<div class="modal-header">
  <h4 class="modal-title pull-left">{{'CONTROL_POINT.ADD_SEISMOGRAPH' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <form #form="ngForm" id="myForm" >
    <div class="form-group">
      <label for="serialNumber">{{'CONTROL_POINT.SERIAL_NUMBER' | translate}}</label>
      <input id="serialNumber" type="text" name="serialNumber" #serialNumber="ngModel" class="form-control" placeholder="{{'CONTROL_POINT.SERIAL_NUMBER' | translate}}" maxlength="256" [(ngModel)]="sismographSelected.equipementId" required />
      @if (!serialNumber.valid && form.submitted) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
      }
    </div>

    <div class="form-group">
      <label for="selectPoint">{{ 'CONTROL_POINT.CONTROL_POINT' | translate }} </label>
      <ng-select [items]="listPoints"
        [virtualScroll]="true"
        bindLabel="name"
        name="point"
        #point="ngModel"
        required
        [(ngModel)]="controlPointSelected">
      </ng-select>
      @if (!point.valid && form.submitted || (isAlert && controlPointSelected.controlPointId === undefined)) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
      }
    </div>

    <div class="btn-toolbar justify-content-between">
      <div class="btn-group" role="group">
        @if (!modif) {
          <button (click)="createSismograph()"  class="btn btn-outline-success">{{'GLOBAL.AJOUTER' | translate}}</button>
        }
        @if (modif) {
          <button  (click)="updateSismograph()"  class="btn btn-outline-success">{{'GLOBAL.MODIFIER' | translate}}</button>
        }
        @if (modif) {
          <button  (click)="deleteSismograph()"  class="btn btn-outline-danger" style="margin-left: 0.5rem;">{{'GLOBAL.SUPPRIMER' | translate}}</button>
        }
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
      </div>
    </div>

  </form>

</div>






